import {
  LayoutDashboard,
  BookOpen,
  FileText,
  FileStack,
  FilePlus,
  FileInput,
  BarChart3,
  Settings,
  User,
  Users,
  Shield,
  Calendar,
  Receipt,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  title: string;
  href: string;
  icon: LucideIcon;
  children?: NavItem[];
}

export const navigation: NavItem[] = [
  {
    title: "Dashboard",
    href: "/",
    icon: LayoutDashboard,
  },
  {
    title: "Contabilidad",
    href: "/contabilidad",
    icon: BookOpen,
    children: [
      {
        title: "Diario",
        href: "/contabilidad/diario",
        icon: BookOpen,
      },
      {
        title: "Plan de Cuentas",
        href: "/contabilidad/cuentas",
        icon: BookOpen,
      },
      {
        title: "Mayor General",
        href: "/contabilidad/mayor",
        icon: BookOpen,
      },
    ],
  },
  {
    title: "Facturacion",
    href: "/facturacion",
    icon: FileText,
    children: [
      {
        title: "Emision",
        href: "/facturacion/emision",
        icon: FilePlus,
      },
      {
        title: "Recepcion",
        href: "/facturacion/recepcion",
        icon: FileInput,
      },
    ],
  },
  {
    title: "Reportes",
    href: "/reportes",
    icon: BarChart3,
    children: [
      {
        title: "Balance General",
        href: "/reportes/balance",
        icon: BarChart3,
      },
      {
        title: "Estado de Resultados",
        href: "/reportes/resultados",
        icon: BarChart3,
      },
      {
        title: "Flujo de Efectivo",
        href: "/reportes/flujo-efectivo",
        icon: BarChart3,
      },
    ],
  },
  {
    title: "Configuracion",
    href: "/configuracion",
    icon: Settings,
    children: [
      {
        title: "Impuestos",
        href: "/configuracion/autoridad-tributaria",
        icon: Receipt,
      },
      {
        title: "Calendario Fiscal",
        href: "/configuracion/calendario-fiscal",
        icon: Calendar,
      },
      {
        title: "Perfil",
        href: "/configuracion/perfil",
        icon: User,
      },
      {
        title: "Usuarios",
        href: "/configuracion/usuarios",
        icon: Users,
      },
      {
        title: "Roles",
        href: "/configuracion/roles",
        icon: Shield,
      },
    ],
  },
];
